/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RtSandboxRouteImport } from './routes/rt-sandbox'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminSetsRouteImport } from './routes/_admin/sets'
import { Route as AdminQuestionsRouteImport } from './routes/_admin/questions'
import { Route as AdminProfileRouteImport } from './routes/_admin/profile'
import { Route as AdminPreferencesRouteImport } from './routes/_admin/preferences'
import { Route as AdminImportRouteImport } from './routes/_admin/import'
import { Route as AdminFieldRouteImport } from './routes/_admin/field'
import { Route as AdminCurriculumRouteImport } from './routes/_admin/curriculum'
import { Route as AdminConsoleRouteImport } from './routes/_admin/console'
import { Route as AdminAddRouteImport } from './routes/_admin/add'
import { Route as AdminPreferencesIndexRouteImport } from './routes/_admin/preferences/index'
import { Route as AdminSetsIdRouteImport } from './routes/_admin/sets_.$id'
import { Route as AdminPreferencesInterfaceRouteImport } from './routes/_admin/preferences/interface'

const RtSandboxRoute = RtSandboxRouteImport.update({
  id: '/rt-sandbox',
  path: '/rt-sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSetsRoute = AdminSetsRouteImport.update({
  id: '/sets',
  path: '/sets',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuestionsRoute = AdminQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPreferencesRoute = AdminPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AdminRoute,
} as any)
const AdminImportRoute = AdminImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFieldRoute = AdminFieldRouteImport.update({
  id: '/field',
  path: '/field',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCurriculumRoute = AdminCurriculumRouteImport.update({
  id: '/curriculum',
  path: '/curriculum',
  getParentRoute: () => AdminRoute,
} as any)
const AdminConsoleRoute = AdminConsoleRouteImport.update({
  id: '/console',
  path: '/console',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAddRoute = AdminAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPreferencesIndexRoute = AdminPreferencesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPreferencesRoute,
} as any)
const AdminSetsIdRoute = AdminSetsIdRouteImport.update({
  id: '/sets_/$id',
  path: '/sets/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPreferencesInterfaceRoute =
  AdminPreferencesInterfaceRouteImport.update({
    id: '/interface',
    path: '/interface',
    getParentRoute: () => AdminPreferencesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/rt-sandbox': typeof RtSandboxRoute
  '/add': typeof AdminAddRoute
  '/console': typeof AdminConsoleRoute
  '/curriculum': typeof AdminCurriculumRoute
  '/field': typeof AdminFieldRoute
  '/import': typeof AdminImportRoute
  '/preferences': typeof AdminPreferencesRouteWithChildren
  '/profile': typeof AdminProfileRoute
  '/questions': typeof AdminQuestionsRoute
  '/sets': typeof AdminSetsRoute
  '/preferences/interface': typeof AdminPreferencesInterfaceRoute
  '/sets/$id': typeof AdminSetsIdRoute
  '/preferences/': typeof AdminPreferencesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/rt-sandbox': typeof RtSandboxRoute
  '/add': typeof AdminAddRoute
  '/console': typeof AdminConsoleRoute
  '/curriculum': typeof AdminCurriculumRoute
  '/field': typeof AdminFieldRoute
  '/import': typeof AdminImportRoute
  '/profile': typeof AdminProfileRoute
  '/questions': typeof AdminQuestionsRoute
  '/sets': typeof AdminSetsRoute
  '/preferences/interface': typeof AdminPreferencesInterfaceRoute
  '/sets/$id': typeof AdminSetsIdRoute
  '/preferences': typeof AdminPreferencesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/rt-sandbox': typeof RtSandboxRoute
  '/_admin/add': typeof AdminAddRoute
  '/_admin/console': typeof AdminConsoleRoute
  '/_admin/curriculum': typeof AdminCurriculumRoute
  '/_admin/field': typeof AdminFieldRoute
  '/_admin/import': typeof AdminImportRoute
  '/_admin/preferences': typeof AdminPreferencesRouteWithChildren
  '/_admin/profile': typeof AdminProfileRoute
  '/_admin/questions': typeof AdminQuestionsRoute
  '/_admin/sets': typeof AdminSetsRoute
  '/_admin/preferences/interface': typeof AdminPreferencesInterfaceRoute
  '/_admin/sets_/$id': typeof AdminSetsIdRoute
  '/_admin/preferences/': typeof AdminPreferencesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/rt-sandbox'
    | '/add'
    | '/console'
    | '/curriculum'
    | '/field'
    | '/import'
    | '/preferences'
    | '/profile'
    | '/questions'
    | '/sets'
    | '/preferences/interface'
    | '/sets/$id'
    | '/preferences/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/rt-sandbox'
    | '/add'
    | '/console'
    | '/curriculum'
    | '/field'
    | '/import'
    | '/profile'
    | '/questions'
    | '/sets'
    | '/preferences/interface'
    | '/sets/$id'
    | '/preferences'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/login'
    | '/rt-sandbox'
    | '/_admin/add'
    | '/_admin/console'
    | '/_admin/curriculum'
    | '/_admin/field'
    | '/_admin/import'
    | '/_admin/preferences'
    | '/_admin/profile'
    | '/_admin/questions'
    | '/_admin/sets'
    | '/_admin/preferences/interface'
    | '/_admin/sets_/$id'
    | '/_admin/preferences/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
  RtSandboxRoute: typeof RtSandboxRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/rt-sandbox': {
      id: '/rt-sandbox'
      path: '/rt-sandbox'
      fullPath: '/rt-sandbox'
      preLoaderRoute: typeof RtSandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/sets': {
      id: '/_admin/sets'
      path: '/sets'
      fullPath: '/sets'
      preLoaderRoute: typeof AdminSetsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/questions': {
      id: '/_admin/questions'
      path: '/questions'
      fullPath: '/questions'
      preLoaderRoute: typeof AdminQuestionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/profile': {
      id: '/_admin/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/preferences': {
      id: '/_admin/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof AdminPreferencesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/import': {
      id: '/_admin/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AdminImportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/field': {
      id: '/_admin/field'
      path: '/field'
      fullPath: '/field'
      preLoaderRoute: typeof AdminFieldRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/curriculum': {
      id: '/_admin/curriculum'
      path: '/curriculum'
      fullPath: '/curriculum'
      preLoaderRoute: typeof AdminCurriculumRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/console': {
      id: '/_admin/console'
      path: '/console'
      fullPath: '/console'
      preLoaderRoute: typeof AdminConsoleRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/add': {
      id: '/_admin/add'
      path: '/add'
      fullPath: '/add'
      preLoaderRoute: typeof AdminAddRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/preferences/': {
      id: '/_admin/preferences/'
      path: '/'
      fullPath: '/preferences/'
      preLoaderRoute: typeof AdminPreferencesIndexRouteImport
      parentRoute: typeof AdminPreferencesRoute
    }
    '/_admin/sets_/$id': {
      id: '/_admin/sets_/$id'
      path: '/sets/$id'
      fullPath: '/sets/$id'
      preLoaderRoute: typeof AdminSetsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/preferences/interface': {
      id: '/_admin/preferences/interface'
      path: '/interface'
      fullPath: '/preferences/interface'
      preLoaderRoute: typeof AdminPreferencesInterfaceRouteImport
      parentRoute: typeof AdminPreferencesRoute
    }
  }
}

interface AdminPreferencesRouteChildren {
  AdminPreferencesInterfaceRoute: typeof AdminPreferencesInterfaceRoute
  AdminPreferencesIndexRoute: typeof AdminPreferencesIndexRoute
}

const AdminPreferencesRouteChildren: AdminPreferencesRouteChildren = {
  AdminPreferencesInterfaceRoute: AdminPreferencesInterfaceRoute,
  AdminPreferencesIndexRoute: AdminPreferencesIndexRoute,
}

const AdminPreferencesRouteWithChildren =
  AdminPreferencesRoute._addFileChildren(AdminPreferencesRouteChildren)

interface AdminRouteChildren {
  AdminAddRoute: typeof AdminAddRoute
  AdminConsoleRoute: typeof AdminConsoleRoute
  AdminCurriculumRoute: typeof AdminCurriculumRoute
  AdminFieldRoute: typeof AdminFieldRoute
  AdminImportRoute: typeof AdminImportRoute
  AdminPreferencesRoute: typeof AdminPreferencesRouteWithChildren
  AdminProfileRoute: typeof AdminProfileRoute
  AdminQuestionsRoute: typeof AdminQuestionsRoute
  AdminSetsRoute: typeof AdminSetsRoute
  AdminSetsIdRoute: typeof AdminSetsIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAddRoute: AdminAddRoute,
  AdminConsoleRoute: AdminConsoleRoute,
  AdminCurriculumRoute: AdminCurriculumRoute,
  AdminFieldRoute: AdminFieldRoute,
  AdminImportRoute: AdminImportRoute,
  AdminPreferencesRoute: AdminPreferencesRouteWithChildren,
  AdminProfileRoute: AdminProfileRoute,
  AdminQuestionsRoute: AdminQuestionsRoute,
  AdminSetsRoute: AdminSetsRoute,
  AdminSetsIdRoute: AdminSetsIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
  RtSandboxRoute: RtSandboxRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
